import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { formatNumberByLocale, type Locale, parseLocale } from '@/utils/localeFormatters';

import { type AuditText, renderAuditText } from './text';

/** Whole numbers get the language's digit grouping; anything else shows as recorded. */
export function formatAuditNumber(value: number, locale: Locale): string {
    return Number.isInteger(value) ? formatNumberByLocale(value, locale, 0) : String(value);
}

/** Renders the texts the audit helpers return in the current language. */
export function useAuditText(): (text: AuditText) => string {
    const { t, i18n } = useTranslation();
    const locale = parseLocale(i18n.language);
    return useCallback(
        (text: AuditText) => renderAuditText(text, t, (value) => formatAuditNumber(value, locale)),
        [t, locale]
    );
}
